import * as apiClient from '../api/apiClient';

import { buildPagedQuery } from '../api/pagedQuery';

import {

  toBulkUploadPayload,

  unwrapPagedResponseModel,

  unwrapResponseModel

} from './studentsDto';



const INDEX_PATH = '/api/Students/Index';

export function resetStudentsListCacheForTests() {
  // Sin caché deduplicada tras F4-011.
}



async function requestAndUnwrap(requestPromise) {

  const { data } = await requestPromise;

  return unwrapResponseModel(data);

}



export function listStudents(query = { page: 1, pageSize: 10 }) {

  const qs = buildPagedQuery(query);

  return apiClient.get(`${INDEX_PATH}?${qs}`).then(({ data }) => unwrapPagedResponseModel(data));

}



export function getStudent(id) {

  return requestAndUnwrap(apiClient.get(`/api/Students/${id}`));

}



export function deleteStudent(id) {

  return requestAndUnwrap(apiClient.get(`/api/Students/delete/${id}`));

}



export function saveStudent(payload) {

  return requestAndUnwrap(apiClient.post('/api/Students', payload));

}



export function uploadFirstYearBulk(archivoBase64) {

  return requestAndUnwrap(apiClient.post('/api/Students/archivo', toBulkUploadPayload(archivoBase64)));

}


